import { useQuery } from 'react-query';
import deliveryDataService from '../services/delivery-data-api'


export const useQueryFetchDeliveryData = (restaurantId: string, options: any) => {
    return useQuery(['statistics', restaurantId], () => deliveryDataService.getDeliveryData(restaurantId), {
        refetchOnWindowFocus: false,
        ...options,

    });
};